var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.post.operation != 'success_create_automatic_network')?_c('span',{domProps:{"innerHTML":_vm._s(
            _vm.$t(`feed.operations.${_vm.operation}`, {
                valuer: `<a href='profile/${_vm.post.valuer.id}'>${_vm.post.valuer.name}</a>`,
                evaluated: `<a href='profile/${_vm.post.evaluated.id}'>${_vm.post.evaluated.name}</a>`,
                type: _vm.$t(`values.network.types.${_vm.post.artifact.type}`),
            })
        )}}):_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('feed.fields.successCreateUsersNetworkMessage'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }